// This file was automatically generated  
// Don't edit this file manually

// Amazon Cognito Region 
module.exports.COGNITO_REGION = "us-east-1";

// Amazon Cognito User Pool ID 
module.exports.COGNITO_POOL_ID = "us-east-1_cbyRS7Yij";

// Amazon Cognito Client ID 
module.exports.COGNITO_CLIENT_ID = "6qsbu1086iot7s50phe9j2omk6";

// API Key to access the REST APIs 
module.exports.PENTOS_API_KEY = "DXYTdpCneT4VZjhanQNtw1hIXOfzZfWW3C7VJ7O1";

// URL to get the first segment of simulation data  (no authorization is required yet)
module.exports.SIM_INIT_URL = "https://d1x4dq1c8mlo6o.cloudfront.net/sim_init";

// URL to post results of the previous segment and get the next segment of simulation data
// (requires  PENTOS_API_KEY and id_token)
module.exports.SIM_UPDATE_URL = "https://29zjf84dxl.execute-api.us-east-1.amazonaws.com/Test/sim_data";

// SimGPS REST API URL  
// (requires  PENTOS_API_KEY and id_token)
module.exports.SIM_GPS_API_URL = "https://29zjf84dxl.execute-api.us-east-1.amazonaws.com/Test";

